import React from 'react';
import { ExternalLink } from 'lucide-react';
import BigNumber from 'bignumber.js';

interface WalletActionsProps {
  onWithdraw: () => void;
  onClose: () => void;
  loading: boolean;
  wei: BigNumber;
}

export function WalletActions({ onWithdraw, onClose, loading, wei }: WalletActionsProps) {
  return (
    <div className="space-y-4">
      <button
        onClick={onWithdraw}
        disabled={loading || wei.isZero()}
        className="w-full py-3 px-4 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 rounded-lg transition-colors flex items-center justify-center gap-2 text-white"
      >
        <ExternalLink size={20} />
        Withdraw to MetaMask
      </button>

      <button
        onClick={onClose}
        className="w-full py-3 px-4 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-white"
      >
        Close
      </button>
    </div>
  );
}